export default {
    getAllHomes: () => {
        return {
            url: '/fhe/homes',
            method: 'GET'
        };
    },
    getHomeDetails: homeId => {
        return {
            url: '/fhe/homes/:homeId',
            method: 'GET',
            route_params: {
                homeId
            }
        };
    },
    updateHomeDetails: (homeId, homeForm) => {
        return {
            url: '/fhe/homes/:homeId',
            method: 'PATCH',
            route_params: {
                homeId
            },
            patch_params: {
                label: homeForm.label,
                address: homeForm.address,
                city: homeForm.city,
                postalCode: homeForm.postalCode,
                isThreephase: !!homeForm.isThreephase,
                jpme: !!homeForm.jpme,
                weatherCity: homeForm.weatherCity,
                meter: homeForm.meter,
                kWhPrice: homeForm.kWhPrice,
                generator: homeForm.generator,
                orientation: homeForm.orientation,
                roofPitch: homeForm.roofPitch,
                constructionDensity: homeForm.constructionDensity,
                moduleType: homeForm.moduleType,
                altitude: homeForm.altitude,
                latitude: homeForm.latitude,
                longitude: homeForm.longitude
            }
        };
    },
    addHome: form => {
        const params = {};
        const homeForm = {};
        Object.keys(form.home).map(field => {
            if (form.home[field] !== null) homeForm[field] = form.home[field];
        });
        params.home = homeForm;

        if (form.user) {
            const userForm = {};
            Object.keys(form.user).map(field => {
                if (form.user[field] !== null) userForm[field] = form.user[field];
            });
            params.user = userForm;
        }
        return {
            url: '/fhe/homes/add',
            method: 'PATCH',
            patch_params: params
        };
    },
    resetPassword: (userId, homeId) => {
        return {
            url: '/fhe/users/:userId/reset-password',
            method: 'POST',
            route_params: {
                userId
            },
            post_params: {
                homeId
            }
        };
    },
    getHomeUsers: homeId => {
        return {
            url: '/fhe/homes/:homeId/users',
            method: 'GET',
            route_params: {
                homeId
            }
        };
    },
    deleteHomeUser: (homeId, userId) => {
        return {
            url: '/fhe/homes/:homeId/delete-user',
            method: 'POST',
            route_params: {
                homeId
            },
            post_params: {
                userId
            }
        };
    },
    addHomeUser: (homeId, userForm) => {
        let params = {};
        Object.keys(userForm).map(field => {
            if (userForm[field] !== null) params[field] = userForm[field];
        });
        return {
            url: '/fhe/homes/:homeId/add-users',
            method: 'POST',
            route_params: {
                homeId
            },
            post_params: params
        };
    },
    editHomeUser: (homeId, userId, userForm) => {
        return {
            url: '/fhe/homes/:homeId/edit-user/:userId',
            method: 'PATCH',
            route_params: {
                homeId,
                userId
            },
            patch_params: userForm
        };
    },
    getHomeHistory: (homeId, withActions) => {
        return {
            url: '/fhe/homes/:homeId/history',
            method: 'GET',
            route_params: {
                homeId
            },
            get_params: {
                withActions
            }
        };
    },
    addHomeHistory: (homeId, historyForm) => {
        let params = {};
        Object.keys(historyForm).map(field => {
            if (historyForm[field] !== null) params[field] = historyForm[field];
        });
        return {
            url: '/fhe/homes/:homeId/add-history',
            method: 'POST',
            route_params: {
                homeId
            },
            post_params: params
        };
    },
    getJournalisation: (homeId, fromDate, toDate) => {
        return {
            url: '/fhe/homes/:homeId/journalisation',
            method: 'GET',
            route_params: {
                homeId
            },
            get_params: {
                fromDate,
                toDate
            }
        };
    },
    emailExists: email => {
        return {
            url: '/fhe/homes/email-exists/:email',
            method: 'GET',
            route_params: {
                email
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/fhe/data/Homes/api.js